import { Effect } from "../../Materials/effect";
var name = 'shadowMapVertexDeclaration';
var shader = "#if SM_NORMALBIAS == 1\nuniform vec3 lightDataSM;\n#endif\nuniform vec3 biasAndScaleSM;\nuniform vec2 depthValuesSM;\nvarying float vDepthMetricSM;\n#if SM_USEDISTANCE == 1\nvarying vec3 vPositionWSM;\n#endif\n#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP == 1\nvarying float zSM;\n#endif\n";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var shadowMapVertexDeclaration = { name: name, shader: shader };
//# sourceMappingURL=shadowMapVertexDeclaration.js.map